const IXOR = (a, b) => {
	// eslint-disable-next-line no-return-assign
	return (a ^= b);
};

export default IXOR;
